<template>
    <div class="card">
        <slot></slot>
    </div>
</template>

<style>
.card {
    @apply flex bg-pampas p-3.5;
}
</style>
